import { get, mapKeys, isObject } from 'lodash'
import { SubmissionError } from 'redux-form'

export const handleSumbissionErrors = errorResponse => {
  const errors = get(errorResponse, 'response.body.errors')

  // TODO:
  // signature
  // (errorResponse, dispatch) =>
  // if 401
  // dispatch(logout())

  if (isObject(errors)) {
    throw new SubmissionError(
      mapKeys(errors, (value, key) => {
        // TODO: Avoid this pain hardcoing
        if (key === 'children[current_password].data') {
          return 'current_password'
        }
        const localKey = get(key.split('.'), '[1]', key)
        if (localKey === 'plainPassword') {
          return 'password'
        }
        return localKey
      })
    )
  }
  // Not a submission error...
  return Promise.reject(errorResponse)
}



// WEBPACK FOOTER //
// ./src/form/errors.js